export const UPDATE_USER_INFO = "UPDATE_USER_INFO";

export const AI_PPT_SCROLL = "AI_PPT_SCROLL";

export const UPDATE_PRICE = "UPDATE_PRICE";
